<template>
  <div class="title">
    <div class="left"></div>
    <div class="name">  <slot></slot> </div>
    <div class="right"></div>
  </div>
</template>

<script>

  export default {

    data () {
      return{}
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .title{
    height: 35px;
    /*background-image: url("../../assets/img/Flowerbg.jpg");*/
    background-image: url("Flowerbg.jpg");
    background-size: 25px;
    display: flex;
  }
  .name{
    line-height: 35px;
    padding: 0 15px;
    color: #ffffe0;
    font-size: 18px;
  }
  .left{
    height: 35px;
    background: url("flowerLeft.svg") no-repeat right;
    background-size: 60px;
    flex: 1;
  }
  .right{
    height: 35px;
    background: url("flowerRight.svg")no-repeat left;
    background-size: 60px;
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/typeTitle/typeTitle.vue